import React from 'react';
import { connect } from 'react-redux';
import { HashLink } from 'react-router-hash-link';

const Footer = () => {
    return (
        <footer className="bg-dark-900 border-t border-white/10 relative overflow-hidden">
            {/* Subtle glow */}
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-1/2 h-24 bg-accent-blue/10 blur-[80px] rounded-t-full top-auto" />
            
            <div className="container mx-auto px-4 py-12 relative z-10">
                <div className="flex flex-col md:flex-row justify-between items-center gap-6">
                    <div className="text-center md:text-left">
                        <HashLink smooth to="/#home" className="text-2xl font-display font-bold text-white no-underline tracking-tighter">
                            Cesar<span className="text-accent-cyan">.</span>
                        </HashLink>
                        <p className="text-slate-400 mt-2 text-sm max-w-sm">
                            Desarrollador Web Full Stack con pasión por crear experiencias digitales excepcionales y modernas.
                        </p>
                    </div>
                    
                    <div className="flex flex-col items-center md:items-end">
                        <div className="text-slate-500 text-sm font-medium tracking-wide">
                            © 2026. Diseñado por Cesar Fuentes. <br className="md:hidden" /> Todos los derechos reservados.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

const mapStateToProps = state => ({});

export default connect(mapStateToProps, {})(Footer);